import { render, staticRenderFns } from "./PanelCloser.vue?vue&type=template&id=df4b27d2"
import script from "./PanelCloser.vue?vue&type=script&lang=ts"
export * from "./PanelCloser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports